import React from "react";

const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Get To Know Me
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Paul Levitsky,</span> a developer
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              who is passionate about bringing engaging experiences to users. 
             From hand crafting web experiences, to designing and implementing training & simulation solutions. 
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
             My professional journey is defined by a unique fusion of high-stakes problem-solving, educational expertise, and technical rigor. I began my career as a Wilderness First Responder and survival instructor, where I mastered the ability to manage complex, unpredictable environments—a skill set that directly informed my transition into teaching Science, History, and English in Korea. It was during this time that I began developing games as pedagogical tools, an endeavor that propelled me into the industry as a developer at Bohemia Interactive Simulations (now OneArc). As a Solutions Engineer, I bridge the gap between sophisticated simulation technology and end-user needs, successfully prototyping and architecting solutions that win contracts and scale globally. I offer a rare perspective that combines the disciplined adaptability of a survivalist, the clear communication of a veteran educator, and the technical craftsmanship of a seasoned game developer.
            </p>
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Paul Levitsky
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:pasha.account@gmail.com">pasha.account@gmail.com</a>
                </li>
                <li>
                  <span className="fw-600 me-2">Current Location:</span>Pittsburgh, PA
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>New Jersey, USA
                </li>
              </ul>
              <a
                href="https://drive.google.com/file/d/1q3hnazTfuq6ypPSKabfcuA29XO0daavb/view"
                target="_blank"
                rel="noopener noreferrer"
                /* download="Paul Levitsky - Full-stack Developer - CV Resume" */
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          {/* <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>250</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Happy Clients
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>650</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>38</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>
          </div> */}
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
